import { render, staticRenderFns } from "./PptMain.vue?vue&type=template&id=5154f532&"
import script from "./PptMain.vue?vue&type=script&lang=js&"
export * from "./PptMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5154f532')) {
      api.createRecord('5154f532', component.options)
    } else {
      api.reload('5154f532', component.options)
    }
    module.hot.accept("./PptMain.vue?vue&type=template&id=5154f532&", function () {
      api.rerender('5154f532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptMain.vue"
export default component.exports